export default "__VITE_ASSET__CZz_8lMG__"